export enum AIEmbeddingType {
    CASE_STUDY = 'caseStudy',
}

export enum SearchIndex {
    PROFILE_SEARCH_INDEX = 'profile_search_index',
    COMPONENT_SEARCH_INDEX = 'component_search_index',
    PROJECTS_SEARCH_INDEX = 'projects_search_index',
    INDUSTRY_SUBCATEGORIES_SEARCH_INDEX = 'industrysubcategories_search_index',
    SEARCH_SYNONYMS = 'searchSynonyms',
    COMPONENT_INDEX = 'vector_search_index',
    MANUFACTURER_INDEX = 'vector_search_index',
    CASE_STUDY_INDEX = 'vector_search_index_case_study',
    ARTICLE_TEXT_INDEX = 'article_text_search_index',
    PRODUCT_SERIES_SEARCH_INDEX = 'product_series_search_index',
}
